/**
 * @file permission.tsx
 * @module app/modals/permission
 * @description Renders the permission modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Button, Modal } from 'react-bootstrap';
import CrossSvg from '../../_admin/assets/media/svg_uTrade/cross-rounded-gray.svg';

const PermissionModal = (props: any) => {

  return (
    <>
      <Modal
        {...props}
        size="md"
        show={props.show}
        onHide={props.onHide}
        dialogClassName="modal-dialog-centered min-w-100px"
        className="border-r10px"
        centered
        backdrop="static"
      >
        <Modal.Body className="">
          <Modal.Title className="fs-24 fw-bolder text-center p-2 m-2">
            {props.error ? props.error :
            `You do not have sufficient permission to access ${props.moduleName} module`}
          </Modal.Title>
          <div className='text-center'>
            <Button className="uw-btn uw-btn-primary uw-btn-lg"
                variant="primary"
                size="lg"
                onClick={props.onHide}
                disabled={props.loading}
              >
                {!props.loading ? (
                  <span className="indicator-label fs-16 fw-bold">
                    Ok
                  </span>
                ) : (
                  <span
                    className="indicator-progress fs-16 fw-bold"
                    style={{ display: 'block' }}
                  >
                    Please Wait
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default PermissionModal;
